import {Button} from 'platform/components';
import {Show, Space} from 'platform/foundation';

import {useLocation} from 'react-router-dom';

import {sourcingRoutes} from '@dms/routes';
import {useEntityNavigation} from '@dms/shared';
import {Navigation} from '@dms/sourcing';

import {RequiredTestIdProps, suffixTestId} from 'shared/web';

import {RowControlWrapper} from 'features/datagrid';

function SourcingNavigation(props: RequiredTestIdProps) {
  return <Navigation data-testid={suffixTestId('navigation', props)} />;
}

function GeneralNavigation(props: RequiredTestIdProps) {
  const {
    handleBreadcrumb,
    handleNavigate,
    isRowControlDetailVisible,
    breadcrumbProps,
    isBreadcrumbVisible,
  } = useEntityNavigation();

  return (
    <>
      <Show when={isBreadcrumbVisible}>
        <Button
          leftIcon="navigation/arrow_back"
          title={breadcrumbProps?.title}
          variant="link"
          onClick={handleBreadcrumb}
          data-testid={suffixTestId('back-button', props)}
        />
      </Show>
      <Space horizontal={5} />
      <Show when={isRowControlDetailVisible}>
        <RowControlWrapper onChange={handleNavigate} />
      </Show>
    </>
  );
}

export function PageNavigation(props: RequiredTestIdProps) {
  const location = useLocation();

  if (location.pathname.includes(sourcingRoutes.home)) {
    return <SourcingNavigation data-testid={props['data-testid']} />;
  }

  return <GeneralNavigation data-testid={props['data-testid']} />;
}
